import { render } from "./App.vue?vue&type=template&id=3d5c29c4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3d5c29c4&lang=css"

import exportComponent from "B:\\GitHub\\Nakronpao\\Nakronpao-health\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__